import { Link } from "react-router-dom";

import Logo from './../../assets/images/logo.png';
import LogoWhite from './../../assets/images/logo-white.png'
import CloseIcon from './../../assets/images/icon/close.png';

const NavigationColored = () => {
  return (
      <nav className="main-nav main-nav-colored navbar navbar-expand-lg" style={{ boxShadow:'none'}}>
        <div className="container-fluid">
          {/* Logo */}
          <a className="navbar-brand" href="/">
            <img className="logo-main" src={Logo} alt="logo" />
            <img className="logo-white" src={LogoWhite} alt="logo-white" />
          </a>
          <Link to="/#services" className="mt-0">
                <img className="close-img" src={CloseIcon} alt="Close" />
          </Link>
        </div>
      </nav>


  );
};
export default NavigationColored;